import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { sortByColumn } from './utils/sorters';
import { ExchangeAntimalwareScanTaskTargetExclusion } from '@nirvana/shared/dtos/types/policies/common';

export class GzExchangeAntimalwareScanTaskExclusionsGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ExchangeAntimalwareScanTaskTargetExclusion
> {
  sortByColumnMethod(
    a: ExchangeAntimalwareScanTaskTargetExclusion,
    b: ExchangeAntimalwareScanTaskTargetExclusion,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }
}
